import React from 'react';
import CookieConsent, {Cookies} from "react-cookie-consent";
import { connect } from 'react-redux';

import {
    Button,
    FormControlLabel,
    Checkbox,
    Container,
    Link,
} from '@material-ui/core';

import {
    t,
    Translate
} from "src/shared_modules/i18n";

import {
    showStaticContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    openContentOrPageClickHandler
} from "src/shared_modules/veu-visitors-core/components/content-view/utils";

import {
    SYSTEM_CONTENT
} from "src/constants";

import './cookie-consent.css';

class CookieOverlay extends React.Component {

    renderOptions() {
        return (<Container maxWidth="sm">
                    <p>
                        <Translate>cookieConsent.message</Translate>
                        <br />
                        <Link color="secondary" onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.COOKIE_POLICY); }} >
                            <Translate>cookieConsent.button</Translate>
                        </Link>
                    </p>
                    {this.createCheckbox('essential', true, true)}
                    {this.createCheckbox('statistic', false, false)}
                    {this.createCheckbox('marketing', false, false)}
            </Container>
        );
    }

    createCheckbox(name, defaultChecked, disabled) {
        let checked = defaultChecked;

        Cookies.set(name+'Cookie', checked, {expires:365}, { secure: true });

        return (
                <FormControlLabel
                    control= {
                        <Checkbox
                        name={t("cookieConsent."+name) }
                        defaultChecked={defaultChecked}
                        onChange={() => {checked = !checked; Cookies.set(name+'Cookie', checked, {expires:365}, { secure: true })}}
                        disabled={disabled}
                        />
                    }
                    label={t("cookieConsent."+name)}
                />
        );
    }

    clickConfirmBtn(isConfirmAll) {
        if (isConfirmAll) {
          Cookies.set('statisticCookie', true, {expires:365}, { secure: true });
          Cookies.set('marketingCookie', true, {expires:365}, { secure: true });
        }

        Cookies.set('ourSessionCookieForPublicUser', 'testValue', {expires:365}, { secure: true });

        this.setState({});
    }

    clickTxt() {
        //showPopover("PrivacyPolicy");
    }

    render() {
        let c = Cookies.get('ourSessionCookieForPublicUser');

        if (c) {
          return null;
        }

        return (
            /*<CookieConsent
                onAccept= {this.clickConfirmBtn}
                cookieName="ourSessionCookieForPublicUser"
                //debug={true}
                overlay
                buttonText=<Translate>cookieConsent.confirm</Translate>
                location="top"
                buttonWrapperClasses="licenseeBtnWrapper  MuiContainer-maxWidthSm"
                buttonClasses="licenseeBtn"
                containerClasses="customConsentContainer"
                contentClasses="customConsentContent"
                overlayClasses="customConsentOverlay">

            </CookieConsent>*/
            <div className="customConsentOverlay">
                <div className="customConsentContainer">
                {this.renderOptions()}
                    <div className="user-form-button-bar MuiContainer-maxWidthSm">
                        <Button variant="contained"
                            color="secondary"
                            onClick={() => { this.clickConfirmBtn(true); }}
                            type="submit"
                        >
                            <Translate>cookieConsent.confirm-all</Translate>
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => { this.clickConfirmBtn(false); }}
                            type="submit"
                        >
                            <Translate>cookieConsent.confirm</Translate>
                        </Button>
                    </div>
                </div>
            </div>
        )}
}
const mapDispatchToProps = {
    showStaticContent,
};
export default connect(
    null,
    mapDispatchToProps
)(CookieOverlay);
